import React from 'react';
import classNames from 'classnames';
import styled, { css } from 'styled-components';
import TourGuide from 'src/components/Banners/TourGuide';
import HotelsLoadingPreview from 'src/components/Hotel/HotelsLoadingPreview';
import PenalizedHotels from 'src/routes/SearchPage/components/EmptyFiltration/components/PenalizedHotels';
import { COUNT_HOTELS_FOR_SHOW_PENALIZED } from 'src/routes/SearchPage/constants/hotels';
import {
  HOTEL_LIST_BANNER_SEARCH,
  HotelListBanner,
} from '../../../../components/HotelListBanner';

import type { HotelsProps } from './types';

import ShowMoreHotels from './components/ShowMoreHotels';
import HotelRenderer from '../HotelRenderer';

const Hotels = ({
  hotels,
  visibleLimit,
  penalizedHotelsVisibleLimit,
  fullMapView = false,
  isShownLoading,
  awaitFiltration,
  browser,
  isMobile,
  isEmptyFiltration,
  isWhitelabel = false,
  isHotelOnly,
  className,
  mobileHotelFilter,
}: HotelsProps) => {
  const wrapperClass = classNames({
    'hotels-list': true,
    'hotels-list__small': fullMapView,
    'hotels-list-mobile': isMobile,
  });

  const isSmallCard = fullMapView || browser.lessThan.medium || isMobile;

  const showPenalizedHotels =
    !isEmptyFiltration &&
    hotels.length < COUNT_HOTELS_FOR_SHOW_PENALIZED &&
    !awaitFiltration &&
    !mobileHotelFilter;

  return (
    <main role="main" className={wrapperClass}>
      {isShownLoading ? (
        <HotelsLoadingPreview
          visibleLimit={visibleLimit}
          penalizedHotelsVisibleLimit={penalizedHotelsVisibleLimit}
          smallCard={Boolean(fullMapView || isMobile)}
        />
      ) : (
        <div>
          {hotels
            .slice(0, visibleLimit)
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .map(({ analyticsInfo, ...hotel }, index) => (
              <Wrapper
                key={hotel.tourId}
                className={className}
                isMobile={isMobile}
              >
                {!mobileHotelFilter && (
                  <StyledBanner
                    index={index}
                    type={HOTEL_LIST_BANNER_SEARCH}
                    isWhitelabel={isWhitelabel}
                    isMobile={isMobile}
                  />
                )}

                {index === 2 && !isHotelOnly && !mobileHotelFilter && (
                  <StyledTourGuideBanner
                    isMobile={isMobile || isSmallCard}
                    isHotelOnly={isHotelOnly}
                  />
                )}

                <HotelRenderer
                  {...hotel}
                  isMapCard={false}
                  isMobile={isSmallCard}
                />
              </Wrapper>
            ))}
        </div>
      )}

      <ShowMoreHotels />

      {showPenalizedHotels && <PenalizedHotels />}
    </main>
  );
};

const marginBottomBetweenBlocks = css`
  margin-bottom: 8px;
`;

const StyledTourGuideBanner = styled(TourGuide)`
  ${marginBottomBetweenBlocks}
`;

const Wrapper = styled.div<{ isMobile: boolean }>`
  ${marginBottomBetweenBlocks}
  position: relative;
  ${({ isMobile }) => isMobile && 'padding: 0 8px'};
`;

const StyledBanner = styled(HotelListBanner)`
  ${marginBottomBetweenBlocks}
  z-index: 0;
  position: relative;
`;

export default Hotels;
